module.exports = __webpack_public_path__ + "img/068-djibouti.9d63994b.svg";